export default __webpack_public_path__ + "static/media/check-white.c1d4c01d.svg";